// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"15c2c0ac","453":"aac1b2d4"}[chunkId] + ".chunk.js";
};